import { render, staticRenderFns } from "./AlternativePayments.vue?vue&type=template&id=8c1b078e&"
import script from "./AlternativePayments.vue?vue&type=script&lang=js&"
export * from "./AlternativePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c1b078e')) {
      api.createRecord('8c1b078e', component.options)
    } else {
      api.reload('8c1b078e', component.options)
    }
    module.hot.accept("./AlternativePayments.vue?vue&type=template&id=8c1b078e&", function () {
      api.rerender('8c1b078e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Views/AlternativePayments.vue"
export default component.exports